import React, { FC } from 'react';
import { ICategory } from '../../../model/category/Category';
import { formatISODateStringAsLocal } from '../common/Utils';
import { observer } from 'mobx-react-lite';
import { AbbreviatedString } from '../../components/abbreviated-string/AbbreviatedString';
import { MetaBox, MetaBoxHeader, MetaBoxBody } from '@yakoffice/meta-box';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

interface PropsType {
  category: ICategory,
}


export const CategoryHighlights: FC<PropsType> = observer((props) => {

  const content = () => {
    return (
      <Row>
        <Col>
          <MetaBoxHeader><i className="far fa-calendar-alt" /> Last updated</MetaBoxHeader>
          <MetaBoxBody>{formatISODateStringAsLocal(props.category.updatedAt)}</MetaBoxBody>
        </Col>
        <Col>
          <MetaBoxHeader><i className="far fa-user" /> Updated by</MetaBoxHeader>
          <MetaBoxBody>{props.category.lastAuthor}</MetaBoxBody>
        </Col>
        <Col>
          <MetaBoxHeader><i className="far fa-comment" /> Last comment</MetaBoxHeader>
          <MetaBoxBody>"<AbbreviatedString value={props.category.lastComment} lengthToAbbreviate={40} />"</MetaBoxBody>
        </Col>
        <Col>
          <MetaBoxHeader><i className="fas fa-info" /> Status</MetaBoxHeader>
          <MetaBoxBody
            className={props.category.status === 'live' ? 'text-success fw-bold' : 'text-warning fw-bold'}>{props.category.status.toUpperCase()}</MetaBoxBody>
        </Col>
      </Row>
    );
  };

  return (
    <MetaBox content={content()} />
  );
});
